import PropTypes from 'prop-types';
import { socialsPropTypes } from '../../components/Socials/SocialsPropTypes';
import { authorPropTypes } from '../../components/Author/AuthorPropTypes';
export const authorDetailsPropTypes = {
  /**
   * Author's data
   */
  ...authorPropTypes,
  /**
   * Author's details: description, socials and footerText
   */
  details: PropTypes.shape({
    description: PropTypes.string,
    socials: socialsPropTypes.socials,
    footerText: PropTypes.string
  })
};